export const vesselConstants = {
    VESSEL_FETCHING: 'VESSEL_FETCHING',
    VESSEL_FETCHED: 'VESSEL_FETCHED',
    VESSEL_SUBMITTED: 'VESSEL_SUBMITTED',
    VESSEL_SUBMITTING: 'VESSEL_SUBMITTING',
    GET_VESSELS: 'GET_VESSELS',
    GET_VESSEL_BY_ID: 'GET_VESSEL_BY_ID',
    GET_VESSELSTOWAGETEMPLATE: 'GET_VESSELSTOWAGETEMPLATE',
    GET_VESSELSTOWAGETEMPLATE_BY_CODE: 'GET_VESSELSTOWAGETEMPLATE_BY_CODE',
    GET_VESSEL_FOR_CHANGE: 'GET_VESSEL_FOR_CHANGE',
    GET_PROFIT_CENTER: 'GET_PROFIT_CENTER',
}